import Authenticated from "@/Layouts/Authenticated";
import { Link, usePage } from "@inertiajs/inertia-react";
import { PlusSmIcon } from "@heroicons/react/solid";
import PageHeading from "@/Components/PageHeading";

const Index = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Settings", route: null },
        { name: "User", route: null },
    ];

    const { users } = usePage().props;

    return (
        <div className="py-6">
            <PageHeading heading={"Users"} breadcrumb={breadcrumb}>
                <span>
                    <Link
                        href={route("settings.users.create")}
                        className={"btn-base btn-light"}
                    >
                        <PlusSmIcon
                            className={"-ml-1 mr-2 h-5 w-5 text-gray-500"}
                            aria-hidden={true}
                        />
                        Add User
                    </Link>
                </span>
            </PageHeading>
            <div className="mt-8">
                <div className="min-w-full px-4 sm:px-6 lg:px-8">
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200 overflow-x-auto">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                                    >
                                        #SN
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                                    >
                                        Name
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                                    >
                                        Email
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                                    >
                                        Role
                                    </th>
                                    <th
                                        scope="col"
                                        className="relative px-6 py-4"
                                    >
                                        <span className="sr-only">Actions</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                                {users.map((user, idx) => (
                                    <tr key={idx}>
                                        <td className="whitespace-nowrap px-6 py-4 font-medium text-gray-900">
                                            {idx + 1}
                                        </td>
                                        <td className="whitespace-nowrap px-6 py-4">
                                            <div className="flex items-center">
                                                <div className="h-10 w-10 flex-shrink-0">
                                                    <img
                                                        src={user.avatar}
                                                        alt="Profile Image"
                                                        className="h-10 w-10 rounded-full"
                                                    />
                                                </div>
                                                <div className="ml-4">
                                                    <div className="text-sm font-medium text-gray-900">
                                                        {user.name}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                                            {user.email}
                                        </td>
                                        <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                                            {user.role_name}
                                        </td>
                                        <td className="whitespace-nowrap px-6 py-4 text-right text-sm font-medium">
                                            <Link
                                                href={route(
                                                    "settings.users.edit",
                                                    user.id
                                                )}
                                                className="text-indigo-600 hover:text-indigo-900"
                                            >
                                                Edit
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

Index.layout = (page) => (
    <Authenticated title={"User Management"}>{page}</Authenticated>
);

export default Index;
